import { fontWeight, styled } from "@mui/system"
import { Box } from "@mui/material"

export const StyledMenuItem = styled(Box)({
  fontSize: "0.8em",
})

export const StyledHeader = styled(Box)({
  display: "flex",
  marginBottom: "3px",
  fontWeight: 600,
})

export const StyledSubHeader = styled(Box)({
  display: "flex",
  marginTop: "6px",
  marginBottom: "3px",
  fontWeight: 500,
})

export const StyledRow = styled(Box)({
  display: "flex",
})

export const StyledColumn = styled(Box)({
  flex: "1",

})

export const StyledLeftColumn = styled(Box)({
  width: "70px",
})

export const StyledRightColumn = styled(Box)({
  flex: "1",
})
